/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import * as S from './styles';
import { Either, GetNestedValueArray, NestedKeys } from '../../utils/propsUtil';
import { View } from '../Basic/View/view';
import { Col } from '../Basic/Col/col';
import { Row } from '../Basic/Row/row';

import { Icon } from '@iconify/react';

import { FilterRequest, Paged, PagedListRequest } from 'domain/types/global/pagedListRequest';
import { IPagedListResponse } from 'domain/types/global/pagedListResponse';

interface Props0<T> {
  onChange: (request: PagedListRequest<T>) => void;
  takeValue: number;
  search?: string;
  setSearchBar?: Dispatch<SetStateAction<string | undefined>>
  searchType: NestedKeys<T>[];
  filters?: FilterRequest[]
}

interface Props1<T> {
  paginationState: Paged<T>;
  setPaginationState: Dispatch<SetStateAction<Paged<T>>>;
  originalState: IPagedListResponse<T> | undefined;
}

interface Props2 { }


export type PaginationProps<T, K extends keyof T> = Props0<T> & Either<Props1<T>, Props2>;

export function Pagination<T, K extends keyof T>(props: PaginationProps<T, K>) {
  const [current, setCurrent] = useState<number>(-1);
  const [currentQtd, setCurrentQtd] = useState<number>(0);
  //const [qtdTotalSearch, setQtdTotalSearch] = useState<number>();

  useEffect(() => {
    handleChange(PaginationType.Next);
  }, []);

  // Reseta ao usar filtro e atualizar
  useEffect(() => {
    if (props.filters == null) return;
    setCurrent(0)
  }, [props.filters]);

  useEffect(() => {
    if (props.originalState?.Reset == true) {
      setCurrent(0);
      handlePagination(0, props.takeValue)
    }

  }, [props.originalState?.Reset]);

  useEffect(() => {
    if (props.originalState == undefined || props.originalState?.Result.length == null) {
      return;
    }
    if (currentQtd === 0 && props.originalState?.Result.length !== 0) {
      setCurrentQtd(props.originalState?.Result.length);
    }
  }, [props.originalState]);

  useEffect(() => {
    let delayDebounceFn: NodeJS.Timeout;
    if (props.search !== undefined) {
      delayDebounceFn = setTimeout(() => {
        handleSearch();
        setCurrent(0)
        if (props.setSearchBar && props.search == "") { props.setSearchBar(undefined) }
      }, 1000);
    }

    return () => clearTimeout(delayDebounceFn);
  }, [props.search]);

  function handleSearch() {
    // if(props.search === "" || props.search == undefined){setQtdTotalSearch(undefined)}
    const x = { skip: 0, take: props.takeValue, search: props.search === "" ? null : props.search } as PagedListRequest<T>;
    props.onChange(x);
    handlePaged(x.skip, x.take);
  }

  function handlePaged(skip: number, take: number) {
    if (props.originalState == null) return;

    let result = props.originalState.Result;
    if (props.search !== undefined && props.search !== "") {

      const regex = new RegExp(props.search, 'i');
      result = result.filter(item => {
        const value = GetNestedValueArray(props.searchType, item); // Propriedade aninhada
        return regex.test(String(value))
      });

      // setQtdTotalSearch(result.length)
    }

    /*= Funcionaria se o nome do filtro estivese no Response, o que nem sempre é possivel
    console.log("Before Filter", result)
    if (props.filters != null) {
      result = result.filter((item => {
        props.filters && props.filters.map((f) => {
          if (f.name as keyof T) {
            var values = f.optionsGroup.flatMap(og => og.options?.flatMap(op => op.id as string))
            console.log("Values", values)
            return values.includes(item[f.name as keyof T] as string)
          }else{
            return true
          }
        })
      }))
    }
    */


    if (props.originalState.Filtered == undefined) {
      result = result.slice(skip, take);
    }
    if (result.length == 0 && props.originalState.Result.length < skip) {
      const s = props.originalState.Reset ? 0 : props.originalState.Result.length
      const t = props.originalState.Reset ? props.takeValue : take
      props.onChange({ skip: s, take: t, search: props.search } as PagedListRequest<T>);
    }

    const s = props.originalState.Reset ? 0 : skip
    const t = props.originalState.Reset ? props.takeValue : take

    props.setPaginationState && props.setPaginationState({ skip: s, take: t, Array: result });
  }

  useEffect(() => {
    if (props.paginationState == null) return;
    handlePaged(props.paginationState.skip, props.paginationState.take);
  }, [props.originalState]);

  function handlePagination(skip: number, take: number, search?: string | undefined) {
    const hasValues = props.originalState?.Result != null ? props.originalState.Result.slice(skip, take).length > 0 : false;
    if ((!hasValues || (search != null && search != "")) || props.originalState?.Filtered != undefined) {
      props.onChange({ skip, take: take, search: props.search } as PagedListRequest<T>);
    }
    handlePaged(skip, take);
  }

  function handleChange(method: PaginationType) {
    let currentPage = current;
    const take = props.takeValue;
    const maxPages = Math.ceil((props.originalState?.TotalCount || 0) / props.takeValue);

    switch (method) {
      case PaginationType.Next:
        currentPage++;
        break;
      case PaginationType.Back:
        currentPage--;
        break;
      case PaginationType.First:
        currentPage = 0;
        break;
      case PaginationType.Last:
        currentPage = maxPages - 1;
        break;
    }

    currentPage = Math.max(0, Math.min(currentPage, maxPages - 1));

    const skip = currentPage * props.takeValue;
    handlePagination(skip, skip + take, props.search);
    setCurrent(currentPage);
  }

  const maxOriginal = props.originalState ? props.originalState?.TotalCount : 0;
  const qtdReal = (current * props.takeValue) + props.takeValue;
  const qtd = qtdReal >= maxOriginal ? maxOriginal : qtdReal;

  function handleBtnClick(event: React.MouseEvent<HTMLButtonElement>) {
    const mode = (event.currentTarget as HTMLButtonElement).dataset.mode as PaginationType;
    handleChange(mode);
  }

  return (
    <View>
      <Row>
        <S.Container>
          <Col>
            <S.PaginationButton
              disabled={qtd <= props.takeValue}
              type='button'
              data-mode={PaginationType.First}
              onClick={handleBtnClick}
              iconPosition='left'
              size='md'
            >
              <Icon icon="material-symbols:keyboard-double-arrow-left-rounded" height={20} color={"white"} />
            </S.PaginationButton>
          </Col>
          <Col>
            <S.PaginationButton
              disabled={qtd <= props.takeValue}
              type='button'
              data-mode={PaginationType.Back}
              onClick={handleBtnClick}
              iconPosition='left'
              size='md'
            >
              <Icon icon="material-symbols:keyboard-arrow-left" height={20} color={"white"} />
            </S.PaginationButton>
          </Col>
          {props.paginationState && (
            <Col>
              {maxOriginal !== 0 ? qtd : qtdReal}{maxOriginal !== 0 ? "/" + maxOriginal : ""}
            </Col>
          )}
          <Col>
            <S.PaginationButton
              disabled={
                maxOriginal === 0
                  ? props.paginationState
                    ? (props.paginationState.Array ? props.paginationState.Array.length : 0) < currentQtd
                    : false
                  : props.paginationState
                    ? qtd >= maxOriginal
                    : false
              }
              type='button'
              data-mode={PaginationType.Next}
              onClick={handleBtnClick}
              iconPosition='left'
              size='md'
            >
              <Icon icon="material-symbols:keyboard-arrow-right" height="18px" color={"white"} />
            </S.PaginationButton>
          </Col>
          <Col>
            <S.PaginationButton
              disabled={qtd >= maxOriginal}
              type='button'
              data-mode={PaginationType.Last}
              onClick={handleBtnClick}
              iconPosition='left'
              size='md'
            >
              <Icon icon="material-symbols:keyboard-double-arrow-right-rounded" height="18px" color={"white"} />
            </S.PaginationButton>
          </Col>
        </S.Container>
      </Row>
    </View >
  );
}

/* eslint-disable no-unused-vars */

enum PaginationType {
  Next = "Next",
  Back = "Back",
  First = "First",
  Last = "Last",
}